import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowTriangleBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconArrowTriangleBottom"><Path d="M4.26615 7.6126C3.43667 5.95307 4.64288 4 6.49832 4H17.502C19.3574 4 20.5636 5.95307 19.7341 7.61261L14.2323 18.62C13.3126 20.46 10.6876 20.46 9.76797 18.62L4.26615 7.6126Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowTriangleBottom;
